"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapLayers = void 0;
const react_1 = __importStar(require("react"));
const map_1 = require("../map");
const FabricMapLayersLayer_1 = require("./FabricMapLayersLayer");
const memoize_one_1 = __importDefault(require("memoize-one"));
const util_1 = require("../util");
const FabricMapLayer_1 = __importDefault(require("./FabricMapLayer"));
const feature_id_generator_1 = __importDefault(require("../../utils/features/feature-id-generator"));
const updateFeatureIds = (0, memoize_one_1.default)((layer) => {
    feature_id_generator_1.default.updateFeatureIds(layer);
    return layer;
});
class FabricMapLayers extends react_1.PureComponent {
    constructor(props) {
        super(props);
        this.render = () => {
            const { map, onClick, disableHighlight, highlighted, getFeaturePaint, onHover, onMouseLeave, combineLayers, } = this.props;
            const { features } = this.state;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(util_1.Conditional, { match: !combineLayers }, features.features.map((feature) => {
                    const highlight = !!(highlighted === null || highlighted === void 0 ? void 0 : highlighted.includes(feature.id));
                    return (react_1.default.createElement(FabricMapLayersLayer_1.FabricMapLayer, { key: feature.id, map: map, disableHighlight: disableHighlight, highlight: highlight, idPrefix: `${feature.id}`, feature: feature, onClick: onClick, onHover: onHover, onMouseLeave: onMouseLeave, paint: getFeaturePaint ? getFeaturePaint(feature) : undefined }));
                })),
                react_1.default.createElement(util_1.Conditional, { match: !!combineLayers },
                    react_1.default.createElement(FabricMapLayer_1.default, { layer: features, highlighted: highlighted, disableHighlight: disableHighlight, onMouseClick: onClick, onMouseEnter: onHover, onMouseLeave: onMouseLeave }))));
        };
        this.state = {
            features: props.features,
        };
        console.warn("FabricMapLayers is deprecated in version 1.0.65 and will be removed in the next major release 2.0.0");
    }
    componentWillUnmount() {
        const { features } = this.state;
        feature_id_generator_1.default.resetFeatureIds(features);
    }
}
exports.FabricMapLayers = FabricMapLayers;
FabricMapLayers.getDerivedStateFromProps = (props, state) => {
    if (state.features !== props.features) {
        feature_id_generator_1.default.resetFeatureIds(state.features);
    }
    return {
        features: updateFeatureIds(props.features),
    };
};
exports.default = (0, map_1.withMap)(FabricMapLayers);
